/**
 * @description i18n zh-CN
 * @author wangfupeng
 */

export default {
  // 通用的词
  common: {
    ok: '确定',
    delete: '删除',
    enter: '回车',
  },

  blockQuote: {
    title: '引用',
  },
  codeBlock: {
    title: '代码块',
  },
  color: {
    color: '文字颜色',
    bgColor: '背景色',
    default: '默认颜色',
    clear: '清除背景色',
  },
  divider: {
    title: '分割线',
  },
  emotion: {
    title: '表情',
  },
  fontSize: {
    title: '字号',
    default: '默认字号',
  },
  fontFamily: {
    title: '字体',
    default: '默认字体',
  },
  fullScreen: {
    title: '全屏',
    cancelTitle: '取消全屏',
  },
  header: {
    title: '标题',
    text: '正文',
  },
  image: {
    netImage: '网络图片',
    delete: '删除图片',
    edit: '编辑图片',
    editSize: '修改尺寸',
    preview: '预览图片',
    viewLink: '查看链接',
    src: '图片地址',
    desc: '图片描述',
    link: '图片链接',
    ok: '确定',
    width: '宽度',
    height: '高度',
  },
  indent: {
    decrease: '减少缩进',
    increase: '增加缩进',
  },
  justify: {
    left: '左对齐',
    right: '右对齐',
    center: '居中对齐',
    justify: '两端对齐',
  },
  lineHeight: {
    title: '行高',
    default: '默认行高',
  },
  link: {
    insert: '插入链接',
    text: '链接文本',
    url: '链接地址',
    unLink: '取消链接',
    edit: '修改链接',
    view: '查看链接',
  },
  textStyle: {
    bold: '粗体',
    clear: '清除格式',
    code: '行内代码',
    italic: '斜体',
    sub: '下标',
    sup: '上标',
    through: '删除线',
    underline: '下划线',
  },
  undo: {
    undo: '撤销',
    redo: '重做',
  },
  todo: {
    todo: '待办',
  },
  formatPainter: {
    title: '格式刷',
  },
}
